export const profileConstants = {
  UPDATE_PROFILE_INFO: 'UPDATE_PROFILE_INFO',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  DELETE_PROFILE_PICTURE: 'DELETE_PROFILE_PICTURE',
};
